import type { RuntimeDiagnosticsResponse } from "@cmmd-forge/contracts";

import { spriteInventoryCopy } from "./cloudEnvironmentInventory.logic";
import { DiagnosticsProcessesTable } from "./DiagnosticsProcessesTable";
import { DiagnosticsCard, DiagnosticsNote, DiagnosticsSection } from "./DiagnosticsPanelPrimitives";

export function DiagnosticsMachineInventory({
  inventory,
  error,
  pending,
  probed,
}: {
  readonly inventory: RuntimeDiagnosticsResponse | undefined;
  readonly error: string | undefined;
  readonly pending: boolean;
  readonly probed: boolean;
}) {
  if (!probed) return null;
  return (
    <>
      <DiagnosticsSection
        title="Machine inventory"
        id="diagnostics-tools"
        description={spriteInventoryCopy()}
      >
        <DiagnosticsCard>
          {inventory ? (
            <div className="flex flex-wrap gap-x-4 gap-y-1.5 px-4 py-3">
              {inventory.tools.map((tool) => (
                <span key={tool.name} className="text-xs text-foreground">
                  {tool.name}
                  {tool.status === "error" ? " (failing)" : ""}
                </span>
              ))}
              {inventory.tools.length === 0 ? (
                <DiagnosticsNote>No CLI checks were returned for this Sprite.</DiagnosticsNote>
              ) : null}
            </div>
          ) : (
            <DiagnosticsNote>
              {pending
                ? "Reading this Sprite's Machine inventory…"
                : (error ?? "Recheck did not return Machine inventory.")}
            </DiagnosticsNote>
          )}
        </DiagnosticsCard>
      </DiagnosticsSection>
      {inventory ? (
        <DiagnosticsSection
          title="Processes"
          id="diagnostics-processes"
          description={
            inventory.processCollectionError
              ? "The Sprite image did not return a process list."
              : `${inventory.processes.length} in this Sprite's tree.`
          }
        >
          <DiagnosticsCard>
            <DiagnosticsProcessesTable
              processes={inventory.processes}
              rootPid={inventory.currentProcess?.pid ?? null}
              collectionError={inventory.processCollectionError}
            />
          </DiagnosticsCard>
        </DiagnosticsSection>
      ) : null}
    </>
  );
}
